import { render, staticRenderFns } from "./DialogOverlay.vue?vue&type=template&id=3583a34a&scoped=true"
import script from "./DialogOverlay.vue?vue&type=script&lang=js"
export * from "./DialogOverlay.vue?vue&type=script&lang=js"
import style0 from "./DialogOverlay.vue?vue&type=style&index=0&id=3583a34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583a34a",
  null
  
)

export default component.exports